import { memo } from 'react';
import {
  Box,
  Breakpoint,
  useBreakpoint,
  useBreakpointProp,
  Text,
} from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import {
  Activity,
  AllMessagesScreen,
  Smartico,
  Tab,
  Unread,
  TabBar,
} from './InboxTabNavigatorComponents';
import { Platform } from 'react-native';

function InboxTabNavigator() {
  const { t } = useTranslation('inbox');

  const modalWidth = useBreakpointProp({
    desktop: 500,
    tablet: 500,
    mobile: 600,
  });

  const breakpoint = useBreakpoint();
  const isDesktop = breakpoint === Breakpoint.DESKTOP;
  const isWeb = Platform.OS === 'web';

  return (
    <Tab.Navigator
      style={{ maxWidth: modalWidth }}
      screenOptions={({ route }) => ({
        swipeEnabled: !isDesktop,
        tabBarScrollEnabled: true,
        tabBarStyle: {
          marginHorizontal: 24,
        },
        tabBarIndicatorStyle: { backgroundColor: 'transparent' },
        tabBarItemStyle: { width: 'auto', paddingHorizontal: 0 },
        ...(!isWeb
          ? {
              tabBarLabel: ({ focused }) => {
                const label = route.name;

                return (
                  <Box
                    {...(focused
                      ? {
                          variant: 'gradient',
                          gradient: 'accentBackground',
                        }
                      : {
                          backgroundColor: 'onLightTertiaryBackground',
                        })}
                    borderRadius="radius-full"
                    paddingHorizontal="space-200"
                    paddingVertical="space-200"
                    marginHorizontal="space-100"
                  >
                    <Text
                      variant="input-label"
                      color={
                        focused ? 'accentSurfacePrimary' : 'darkSurfacePrimary'
                      }
                    >
                      {label}
                    </Text>
                  </Box>
                );
              },
            }
          : {}),
      })}
      {...(isWeb ? { tabBar: (props) => <TabBar {...props} /> } : {})}
    >
      <Tab.Screen name={t('all')} component={AllMessagesScreen} />
      <Tab.Screen name={t('promotions')} component={Smartico} />
      <Tab.Screen name={t('activities')} component={Activity} />
      <Tab.Screen name={t('unread')} component={Unread} />
    </Tab.Navigator>
  );
}

export default memo(InboxTabNavigator);
